<template>
  <content-page kind="ad"/>
</template>
<script>import ContentPage from './content-page';

export default {components: {ContentPage}}</script>
